module.exports = __webpack_public_path__ + "img/restaurant_5.54db5269.jpg";